const toDayKey = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

const fromDayKey = (key: string) => {
  const [y, m, d] = key.split('-').map(Number);
  return new Date(y!, m! - 1, d!);
};

const startOfToday = () => fromDayKey(toDayKey(new Date()));

/**
 * Hydration-safe "today" (start of local day).
 *
 * Pages are ISR-cached indefinitely, so the server-rendered HTML can be days old. Filtering by
 * `new Date()` directly makes the client render a different list than the cached HTML, and Vue
 * does not repair `v-html` content on hydration mismatch, leaving descriptions attached to the
 * wrong items. Instead, the server's render day is stored in the payload so hydration matches the
 * cached HTML exactly, then it's swapped for the real client day after mount (a normal re-render).
 */
export const useToday = () => {
  // Stored as a YYYY-MM-DD key (not an ISO timestamp) so server/client timezone differences
  // can't shift the day during hydration.
  const renderDay = useState('render-today', () => toDayKey(new Date()));
  const today = ref(fromDayKey(renderDay.value));

  onMounted(() => {
    today.value = startOfToday();
  });

  return readonly(today);
};
